import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  makeStateKey,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  provideClientHydration,
  withEventReplay,
  withI18nSupport,
} from '@angular/platform-browser';
import {
  API_URL,
  SERVER_API_URL,
  AuthenticationService,
  credentialsInterceptor,
  xsrfInterceptor,
  CONSENT_FORMS_SERVICE,
  ConsentFormsApiService,
  ConsentFormsMockService,
  DIRECTORY_PORTAL_URL,
  GoogleMapsLoaderService,
  LocalStorageService,
  PATIENT_PORTAL_URL,
  provideAuthBootstrap,
  provideGoogleMapsApi,
  PROVIDER_PORTAL_URL,
} from '@services';
import { ExternalSvgModule } from '@ui-lib';
import { provideGoogleClientId } from '../../../services/src/lib/services/google-client-id.provider';
import {
  provideMicrosoftClientId,
  provideMicrosoftTenantId,
} from '../../../services/src/lib/services/microsoft-client-id.provider';
import { provideZoomClientId } from '../../../services/src/lib/services/zoom-client-id.provider';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { GlobalErrorHandler } from './shared/_services/error-handler.service';
import { LocalizationService } from './shared/_services/localization.service';

export const FINAL_URL_KEY = makeStateKey<string>('final-url');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay(), withI18nSupport()),
    provideHttpClient(
      withFetch(),
      withInterceptors([credentialsInterceptor, xsrfInterceptor])
    ),
    importProvidersFrom(ExternalSvgModule),
    provideAuthBootstrap(),
    { provide: API_URL, useValue: environment.apiRootUrl },
    {
      provide: SERVER_API_URL,
      useValue: environment.serverApiRootUrl || environment.apiRootUrl,
    },
    { provide: DIRECTORY_PORTAL_URL, useValue: environment.directoryPortalUrl },
    { provide: PROVIDER_PORTAL_URL, useValue: environment.providerPortalUrl },
    { provide: PATIENT_PORTAL_URL, useValue: environment.patientPortalUrl },
    {
      provide: CONSENT_FORMS_SERVICE,
      useClass: environment.useMock
        ? ConsentFormsMockService
        : ConsentFormsApiService,
    },
    LocalizationService,
    GoogleMapsLoaderService,
    provideGoogleMapsApi(environment.googleMapsApiKey || ''),
    provideGoogleClientId(environment.googleOauthClientId || ''),
    provideZoomClientId(environment.zoomOauthClientId || ''),
    provideMicrosoftClientId(environment.microsoftOauthClientId || ''),
    provideMicrosoftTenantId(environment.microsoftOauthTenantId || ''),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },

    AuthenticationService,
    LocalStorageService,
  ],
};
